<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-camera-home'}"
	[headerText]="(T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_DIALOG_TITLE | translate) + data.camera.ipAddress + '  ' + data.camera.name"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		@if (data?.camera) {
			<div class="row">
				<div class="col-lg-6 col-md-6 col-sm-6">
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_USER_NAME | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.username" matInput type="text" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('Username', data.camera.configuration.username)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_PASSWORD | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.password" matInput type="password" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('Password', data.camera.configuration.password)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_FIRMWARE_VERSION | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.firmewareVersion" matInput type="text" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('FirmewareVersion', data.camera.configuration.firmewareVersion)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_SOURCE_CAMERA_NUMBER | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.sourceCameraNumber" matInput type="number" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('SourceCameraNumber', data.camera.configuration.sourceCameraNumber)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex" style="margin-top: 10px">
						<mat-checkbox [(ngModel)]="data.camera.configuration.audioSupport">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_AUDIO_SUPPORT | translate }}
						</mat-checkbox>
						<button
							(click)="updateAllCameras('AudioSupport', data.camera.configuration.audioSupport)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex" style="margin-top: 20px">
						<mat-checkbox [(ngModel)]="data.camera.configuration.recordAudio" color="primary">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RECORD_AUDIO | translate }}
						</mat-checkbox>
						<button
							(click)="updateAllCameras('RecordAudio', data.camera.configuration.recordAudio)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex" style="margin-top: 20px">
						<mat-checkbox [(ngModel)]="data.camera.configuration.isSecure" color="primary">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_ACCESS_VIDEO_OVER_HTTPS | translate }}
						</mat-checkbox>
						<button
							(click)="updateAllCameras('IsSecure', data.camera.configuration.isSecure)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-6">
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_PAN_TILT_SPEED | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.panTiltSpeed" matInput max="100" min="0" type="number" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('PanTiltSpeed', data.camera.configuration.panTiltSpeed)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_PROXY | translate }}
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.cameraProxy" matInput type="text" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('CameraProxy', data.camera.configuration.cameraProxy)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field>
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_CAMERA_PROXY_TYPE | translate }}
							</mat-label>
							<mat-select [(ngModel)]="data.camera.configuration.cameraProxyType">
								@for (cameraProxyType of cameraProxyTypes; track cameraProxyType) {
									<mat-option [value]="cameraProxyType.value">
										{{ cameraProxyType.name }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<button
							(click)="updateAllCameras('CameraProxyType', data.camera.configuration.cameraProxyType)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label style="pointer-events: auto">
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RECORDING_TIMEOUT | translate }}
								<i
									[matTooltip]="T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RECORDING_TIMEOUT_TOOLTIP | translate"
									class="fad fa-info-circle"
									style="margin-left: 3px"
								>
								</i>
							</mat-label>
							<input [(ngModel)]="data.camera.configuration.recordingTimeout" matInput type="number" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('RecordingTimeout', data.camera.configuration.recordingTimeout)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex">
						<mat-form-field>
							<mat-label>
								{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_ROTATION | translate }}
							</mat-label>
							<mat-select [(ngModel)]="data.camera.configuration.rotation">
								@for (rotation of data.camera.configuration.supportedRotations; track rotation) {
									<mat-option [value]="rotation"> {{ rotation }}° </mat-option>
								}
							</mat-select>
							<mat-hint>{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_ONLY_THIS_CAMERA | translate }}</mat-hint>
						</mat-form-field>
						<button
							(click)="updateAllCameras('Rotation', data.camera.configuration.rotation)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							disabled
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex" style="margin-top: 10px">
						<mat-checkbox [(ngModel)]="data.camera.configuration.useWallclockAsTimestamps" color="primary">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_USE_WALLCLOCK_AS_TIMESTAMPS | translate }}
						</mat-checkbox>
						<button
							(click)="updateAllCameras('UseWallclockAsTimestamps', data.camera.configuration.useWallclockAsTimestamps)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
					<div class="styleFlex" style="margin-top: 20px">
						<mat-checkbox [(ngModel)]="data.camera.configuration.anonymousAccessAllowed" color="primary">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_ANONYMOUS_ACCESS_ALLOWED | translate }}
						</mat-checkbox>
						<button
							(click)="updateAllCameras('AnonymousAccessAllowed', data.camera.configuration.anonymousAccessAllowed)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
				</div>
			</div>
		}
	</ng-container>

	<ng-container actions>
		<a
			#downloadAnchor
			[download]="data.camera.id + '_report.txt'"
			[href]="getCameraReport_Url(data.camera.id)"
			class="large download-button"
			color="accent"
			mat-raised-button
		>
			{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_GET_CAMERA_REPORT | translate }}
		</a>

		<button (click)="restartCamera()" class="large" color="accent" mat-raised-button>
			{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RESTART_CAMERA | translate }}
		</button>

		<button (click)="updateAllCamerasOfType()" [disabled]="!canUpdateAllCamerasOfType()" class="large" color="accent" mat-raised-button>
			{{ T.CONFIGURATION_EDITOR_CAMERA_UPDATE_CAMERAS_OF_TYPE | translate }}
			{{ updateAllCamerasOfTypeText() }}
		</button>

		<sim-button (onClick)="close()" [icon]="{fontSet: 'far', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" [color]="'warn'" />

		<sim-button
			(onClick)="ok()"
			[icon]="{fontSet: 'far', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
